export const FILTERBYSEARCH = "filter/filterBySearch";
export const FILTERBYCATEGORY = "filter/filterByCategory";
